import { createContext, useContext } from 'react'

export interface RuleCardEditState {
  // Whether the card is currently in edit mode (inputs editable). When false,
  // inputs render as read-only display.
  isEditing: boolean
  // Whether the card's master enable toggle is on. When false the rows are
  // gated (dimmed + non-interactive).
  cardEnabled: boolean
}

// Defaults keep any standalone card usage fully editable, matching the prior
// always-editable behaviour before per-card edit mode was introduced.
export const RuleCardEditContext = createContext<RuleCardEditState>({
  isEditing: true,
  cardEnabled: true,
})

export const useRuleCardEdit = (): RuleCardEditState =>
  useContext(RuleCardEditContext)
